import React from 'react';
import PropTypes from 'prop-types';
import {Marker as MapMarker} from 'react-map-gl';
import {AnimatedCanvas} from './AnimatedCanvas';

const size = 75;

export function GeolocationMarker({location: {latitude, longitude}}) {
    const offset = -size / 2;

    return (
        <MapMarker
            latitude={latitude}
            longitude={longitude}
            offsetTop={offset}
            offsetLeft={offset}
        >
            <AnimatedCanvas
                width={size}
                height={size}
                onAnimation={(context, timestamp) => {
                    const duration = 1000;
                    const t = (timestamp % duration) / duration;
                    const radius = (size / 2) * 0.3;
                    const outerRadius = (size / 2) * 0.7 * t + radius;
                    const width = size;
                    const height = size;

                    // draw outer circle
                    context.clearRect(0, 0, width, height);
                    context.beginPath();
                    context.arc(
                        width / 2,
                        height / 2,
                        outerRadius,
                        0,
                        Math.PI * 2
                    );
                    context.fillStyle = `rgba(30, 144, 255, ${1 - t})`;
                    context.fill();

                    // draw inner circle
                    context.beginPath();
                    context.arc(width / 2, height / 2, radius, 0, Math.PI * 2);
                    context.fillStyle = 'rgba(30, 144, 255, 1)';
                    context.strokeStyle = 'white';
                    context.lineWidth = 2 + 4 * (1 - t);
                    context.fill();
                    context.stroke();
                }}
            />
        </MapMarker>
    );
}

GeolocationMarker.propTypes = {
    location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
    }).isRequired,
};
